import { createAsyncThunk } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";
import * as API from "./api";

// get user
export const getUser = createAsyncThunk("user/getUser", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getUser({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });

    const filteredData = data.data.filter((user) => user.isSuperuser === false);
    return { ...data, results: filteredData, count: filteredData?.length };
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all users
export const getAllUser = createAsyncThunk("user/getAllUser", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllUser();
    const filteredData = data.results.filter((user) => user.isSuperuser === false);

    return { ...data, results: filteredData };
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("user/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    const filteredData = data.results.filter((user) => user.isSuperuser === false);
    return { ...data, results: filteredData, count: filteredData?.length };
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("user/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);
    const filteredData = data.results.filter((user) => user.isSuperuser === false);
    return { ...data, results: filteredData, count: filteredData?.length };
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getPageUser = createAsyncThunk("user/getPageUser", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageUser({ number, rowsPerPage: rowsPerPage, search });
    const filteredData = data.results.filter((user) => user.isSuperuser === false);
    return { ...data, results: filteredData, count: filteredData?.length };
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get current user
export const getCurrentUser = createAsyncThunk("user/getCurrentUser", async (token, { rejectWithValue }) => {
  try {
    const decoded = token && jwt_decode(token);
    const { data } = await API.getCurrentUser(decoded);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create user
export const createUser = createAsyncThunk("user/createUser", async (data, { rejectWithValue, dispatch }) => {
  const {
    firstName,
    middleName,
    lastName,
    email,
    username,
    address,
    phone,
    isActive,
    photo,
    designation,
    roles,
    branchRoles,
    permissions,
    branchPermissions,
    departments,
    branch,
    gender,
    password,
    confirmPassword,
  } = data;
  try {
    const body = new FormData();

    body.append("firstName ", firstName);
    body.append("middleName", middleName);
    body.append("lastName", lastName);
    body.append("email", email);
    body.append("username", username);
    body.append("address", address);
    body.append("designation", designation);

    body.append("phone", phone);
    body.append("isActive", isActive);
    body.append("gender", gender);
    body.append("password", password);
    body.append("confirmPassword", confirmPassword);

    body.append("branch", branch);
    await departments.forEach((dep, i) => {
      body.append(`departments[${i}]`, dep);
    });
    await roles.forEach((role, i) => {
      body.append(`roles[${i}]`, role);
    });
    await branchRoles.forEach((branchRole, i) => {
      body.append(`branchRoles[${i}]`, branchRole);
    });
    // await permissions.forEach((per, i) => {
    //   body.append(`permissions[${i}]`, per);
    // });
    // await branchPermissions.forEach((branchPer, i) => {
    //   body.append(`branchPermissions[${i}]`, branchPer);
    // });

    if (photo) {
      body.append("photo", photo);
    }

    const { data } = await API.createUser(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
// update user
export const updateUser = createAsyncThunk("user/updateUser", async (data, { rejectWithValue, dispatch }) => {
  const { id, values } = data;
  const {
    firstName,
    middleName,
    lastName,
    email,
    username,
    address,
    phone,
    isActive,
    photo,
    designation,
    roles,
    branchRoles,
    permissions,
    branchPermissions,
    departments,
    branch,

    gender,
    remarks,
  } = values;
  try {
    const body = new FormData();
    body.append("firstName", firstName);
    body.append("middleName", middleName);
    body.append("lastName", lastName);
    body.append("email", email);
    body.append("username", username);
    body.append("address", address);
    body.append("designation", designation);

    body.append("phone", phone);
    body.append("isActive", isActive);
    body.append("gender", gender);

    body.append("branch", branch);
    if (remarks) {
      body.append("remarks", remarks);
    }
    if (photo) {
      body.append("photo", photo);
    }
    await departments.forEach((dep, i) => {
      body.append(`departments[${i}]`, dep);
    });
    await roles.forEach((role, i) => {
      body.append(`roles[${i}]`, role);
    });
    await branchRoles.forEach((branchRole, i) => {
      body.append(`branchRoles[${i}]`, branchRole);
    });
    await permissions.forEach((per, i) => {
      body.append(`permissions[${i}]`, per);
    });
    await branchPermissions.forEach((branchPer, i) => {
      body.append(`branchPermissions[${i}]`, branchPer);
    });

    const { data } = await API.updateUser(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// get specific user
export const getSpecificUser = createAsyncThunk("user/getSpecificUser", async (id, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await API.getSpecificUser(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// delete user
export const deleteUser = createAsyncThunk("user/deleteUser", async (id, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await API.deleteUser(id);
    dispatch(getUser(10));
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// handle search
export const handleSearch = createAsyncThunk("user/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// delete photo
export const deletePhoto = createAsyncThunk("user/deletePhoto", async (id, { rejectWithValue }) => {
  try {
    const body = JSON.stringify({ photo: "" });
    const { data } = await API.deletePhoto(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
